import { render } from "./back-in-stock-popup.vue?vue&type=template&id=75a06142"
import script from "./back-in-stock-popup.vue?vue&type=script&lang=js"
export * from "./back-in-stock-popup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__